import * as React from 'react';
import { useField } from 'react-final-form';
import { UserSettingsField_Option } from '../../../types/UserFields';
import DateInput from '../../EditBookCard/DateInput/DateInput';
import { parseISO } from 'date-fns';
import Input from '../../Input/Input';
import Select from '../../Select/Select';

interface Props {
	name: string;
	type: string;
	label: string;
	disabled?: boolean;
	options?: UserSettingsField_Option[];
}

const Field: React.FunctionComponent<Props> = props => {
	const field = useField(props.name, {
		type: props.type
	});

	if (props.type === 'select') {
		return <Select
			items={props.options.map(option => ({
				label: option.name,
				value: option.value
			}))}
			label={props.label}
			onChange={e => {
				console.log(e);
				field.input.onChange(e)
			}}
			value={field.input.value ? field.input.value : 0}
		/>
	}

	if (props.type === 'date') {
		return <DateInput
			name={field.input.name}
			label="Дата рождения"
			openDate={field.input.value ? parseISO(field.input.value) : null}
			defaultDate={field.input.value ? parseISO(field.input.value) : null}
			value={field.input.value}
			onChange={field.input.onChange}
			minYear={1940}
			disableDelete={true}
		/>
	}

	return <Input
		name={field.input.name}
		onChange={field.input.onChange}
		value={field.input.value}
		label={props.label}
		variant="filled"
		fullWidth={true}
		disabled={props.disabled}
	/>;
};

export default Field;
